module.exports = __webpack_public_path__ + "static/media/wmTrial-words-1.07c00c47.mp3";